import { ExpansionPanelComponent } from '../expansion-panel.component';
import { PanelBodyDirective, PanelTitleDirective } from '../panel-slots';

export const ExpansionPanelImportPack = [ExpansionPanelComponent, PanelTitleDirective, PanelBodyDirective] as const;
